import { useTranslation } from 'react-i18next'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'

interface IProps {
  users: number
  assignRole: () => void
  close: () => void
}

export const ChangeRole = ({ users, assignRole, close }: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.users.actions.changeRole.modal'

  return (
    <Modal
      isOpen={true}
      title={t(`${prefix}.title`)}
      isConfirmation={true}
      maxwidth={800}
      maxheight={204}
      close={close}
      actions={
        <ModalButtons
          primaryText={t(`${prefix}.buttons.assignRole`)}
          primaryAction={assignRole}
          secondaryText={t(`${prefix}.buttons.cancel`)}
          secondaryAction={close}
        />
      }
    >
      <>
        {`${t(`${prefix}.descriptionPrefix`)} `}
        <span style={{ fontWeight: 'bold' }}>
          {t(`${prefix}.selectedUsers`).replace('{count}', users.toString())}
        </span>
        {` ${t(`${prefix}.descriptionSuffix`)}`}
      </>
    </Modal>
  )
}

export default ChangeRole
